import { useProviderHistoryQuery, useProviderQuery } from '@common/cache';
import { useContext, useEffect, useState } from 'react';
import { AdminPanelDrawerContext } from '@views/pages/Admin/context';

interface IUseProviderItemProps {
  id: string;
  handleClose: () => void;
}

const historyTabIndex = '3';

export const useProviderItem = ({ id, handleClose }: IUseProviderItemProps) => {
  const [historyPage, setHistoryPage] = useState(1);
  const {
    isFormClean,
    handleClear,
    handleCloseTrigger,
    tabIndex,
    handleTriggerChangeTab,
    triggerClose,
  } = useContext(AdminPanelDrawerContext);

  const provider = useProviderQuery({
    provider_id: id,
  });

  const [isProviderInactive, setIsProviderInactive] = useState(
    provider?.data?.inactive,
  );

  const providerHistory = useProviderHistoryQuery({
    provider_id: id,
    page: historyPage,
    limit: 100,
    enabled: historyTabIndex === tabIndex,
  });

  useEffect(() => {
    if (isFormClean && triggerClose) {
      handleClose();
      handleClear();
    }
  }, [isFormClean, triggerClose]);

  useEffect(() => {
    setIsProviderInactive(provider?.data?.inactive);
  }, [provider?.data?.inactive]);

  return {
    provider,
    tabIndex,
    handleTriggerChangeTab,
    providerHistory: providerHistory.data,
    setHistoryPage,
    historyPage,
    handleCloseTrigger,
    historyTabIndex,
    isProviderInactive,
    setIsProviderInactive,
  };
};
